import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_round",
  "use": "icon-arrow_round-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow_round\"><path d=\"m11 5.268c1.333.77 1.333 2.694 0 3.464l-4.5 2.598c-1.333.77-3-.192-3-1.732v-5.196c0-1.54 1.667-2.502 3-1.732z\" fill=\"#d9d9d9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow_round.svg
// module id = aAuE
// module chunks = 87